import Tone from 'tone'; 
import accounts from "accounts/Accounts.js";
import {setClockType} from 'actions/index.js';
import {ipfsHashToBytes32, bytes32ToIPFSHash} from 'utils/ipfsHash.js';
import Transferable from './Transferable.js';
import ClockContract from 'decentralized/contracts/ClockContract.js';
import ipfs from 'decentralized/Ipfs.js'; 
import Room from 'ipfs-pubsub-room';
import pull from 'pull-stream';
import IPFS from 'ipfs';
import {NONE, MASTER, SLAVE} from 'constants/clock-types.js';
import ethereum from 'decentralized/ethereum.js';
import {TRANSFER_TRACK, TICK, DELAY, RESPONSE, STOP, BPM_CHANGED} from 'constants/clock-message-types.js';
import {DISCONNECTED, WAITING, SYNCED} from 'constants/connection-status-types.js';
import {setConnectionStatus} from 'actions/index.js';
import {setConnectedUserName} from 'actions/index.js';
import {setAvailableUsersToSync} from 'actions/index.js';
import {setClockTick} from 'actions/index.js';
import {str2ab, ab2str2} from 'utils/ArrayBufferConverter.js';
import {start} from './MyBundle.js';
var Peer = require('simple-peer');


const TOPIC = 'alecresende';

const web3 = ethereum.web3;

/**
 * ClockSync allows 2 computers to share the same clock. One
 * computer being the master clock, while the other being
 * the slave clock.
 */
class ClockSync extends Transferable(class{}) {
    constructor(sequencerEngine) {
        super();
        this.sequencerEngine = sequencerEngine;
        this.store = this.sequencerEngine.store;
        this.contract = new ClockContract().getContract(ethereum.web3);
        this.listeningForClockSyncs = false;
        this.connected = false;
        this.isInitial = true;
        this.userToSignal = {};
    }

   setClockType(clockType) {
       this.store.dispatch(setClockType(clockType));
       this.initiator = clockType === MASTER;
       this.clockType = clockType;
       if (clockType === NONE) {
           return;
       }
       
       this.setupWebRTC();
       if (this.listeningForClockSyncs !== clockType) {
           this.listenForClockSyncs(clockType);
       }
    }

    retry() {
        this.setupWebRTC();
    }

    startListening() {
        if (!this.connected) {
            this.listenForClockSyncs(SLAVE);
        } else {
            console.log("is connected");
        }
    }

    stopListening() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    // listen for either ClockSyncSlave or ClockSyncMaster ethereum
    // log events, depending on what clock type.
    // For example, a MASTER would listen for SLAVE events
    // and vice-versa.
    async listenForClockSyncs(clockType) {
        if (this.timer){
            clearInterval(this.timer);
        }
        this.listeningForClockSyncs = clockType;

        if (!this.isInitial) {
            this.store.dispatch(setConnectionStatus(WAITING));
        }

        let ownUserId = await accounts.getAccount();
        this.listenCallback(clockType, ownUserId);
        this.timer = setInterval(() => {
            this.listenCallback(clockType, ownUserId);
       }, 10000);
    }

    listenCallback(clockType, ownUserId) {
        let clockToGet = clockType === MASTER ? SLAVE: MASTER;

        fetch('/getClockUsers/' + clockToGet + '/' + ownUserId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(async resp => {
                let json = await resp.json();
                console.log('fetch returned clockType=', clockToGet, clockType);
                console.log(json);
                
                let userNames = [];
                for (let i in json) {
                    let userId = json[i].userId;
                    console.log(json[i]);
                    if (userId === ownUserId) {
                        console.log("user was itself");
                        continue;
                    }
                    let ipfsHash = json[i].signal;
                    
                    let userName = await ethereum.users.getUserName(userId);
                    if (clockType === MASTER) {
                        // This is the MASTER clock and we've noticed a SLAVE has
                        // asked to connect to this MASTER clock.
                        // NOTE: this check should be done in the server
                        // ideally with a cryptographically signed message
                        console.log("master noticed slave wants to connect");
                        this.signal(ipfsHash);
                        this.store.dispatch(setConnectedUserName(userName));
                    } else {
                        if (!(userId in this.userToSignal)) {
                            userNames.push(userName);
                            this.store.dispatch(setAvailableUsersToSync(userNames));
                        }
                    }
                    this.userToSignal[userId] = ipfsHash;
                }
            });
    }

    async syncToUser(userId) {
        this.isInitial = false;
        this.setClockType(SLAVE);
        this.signal(this.userToSignal[userId]);

        let userName = await ethereum.users.getUserName(userId);
        console.log('sync to user the signal for username = ' + userName + ' is ' );
        this.userToConnectTo = userId;
        this.store.dispatch(setConnectedUserName(userName));
    }

    setupWebRTC(withSignal=undefined) {
        return new Promise((resolve, reject) => {
            this.connected = false;
            this.peer = new Peer({
                reconnectTimer: 1000,
                channelConfig: { maxRetransmits: 5, reliable: false, ordered: false },
                initiator: this.initiator,
                trickle: false });
            
            this.peer.on('error', err => {
                console.log(err);
                this.connected = false;
                this.retry();
            });
            this.peer.on('signal', data => this.onSignal(data));
            this.peer.on("connect", () => {
                console.log("GOT CONNECT SIGNAL!!!!");
                this.connected = true;
                this.store.dispatch(setConnectionStatus(SYNCED));
                clearInterval(this.timer);
            });
            
            this.peer.on('data', data => this.onMessageFromPeer(data));

            this.peer.on("close", () => {
                this.connected = false;
                this.store.dispatch(setConnectionStatus(DISCONNECTED));
            });

            resolve();
        });
    }

    onSignal(data) {
        ipfs.addJson(data).then(async (hash) => {
            if (this.clockType === MASTER) {
                console.log("PUBLISHING MASTER=", hash);
                this.publishMaster(hash);
            } else {
                console.log("PUBLISHING SLAVE=", hash);
                this.publishSlave(hash, this.userToConnectTo);
            }
        });
    }

    // called when a message from a peer is received
    async onMessageFromPeer(data) {
        if (data.length > 1000) {
            console.log('big message from peer=', data);
        }
        
        let action = JSON.parse(await ab2str2(data));
        switch (action.type) {
        case TRANSFER_TRACK:
            this.onTransferTrack(action.payload);
            break;
        case TICK:
            this.lastTickTime = new Date().getTime();
            this.step = parseInt(action.payload.step);
            this.time = parseFloat(action.payload.time);
            this.length = parseInt(action.payload.length);
            this.peer.send(JSON.stringify({
                type: DELAY,
                payload: ''
            }));

            this.updateClockTickUI(this.step);

           break;
        case DELAY:
            this.peer.send(JSON.stringify({
                type: RESPONSE
            }));
            break;
        case STOP:
            this.sequencerEngine.stop();
            break;
        case BPM_CHANGED:
            this.sequencerEngine.bpm = action.payload;
            break;
        case RESPONSE:
            this.rtt = new Date().getTime() - this.lastTickTime;
            let latency = this.rtt / 2;
            
            // we check for 2 steps ahead of when we want to play
            // because windows has huge latency 
            let step = this.step % this.sequencerEngine.length;
            let length = this.sequencerEngine.length;
            if (length > this.length) {
                length = this.length;
            }
            if (step === length - 2 &&
                !this.initiator && !this.sequencerEngine.playing &&
               this.isPlayScheduled) {
                let timeToHit = this.lastTickTime - latency + this.time - new Date().getTime();
                timeToHit += new Tone.Time('32n').toMilliseconds();
                this.sequencerEngine.timeToCompare = new Date().getTime() + timeToHit;
                this.sequencerEngine.play();
            }
            break;
        }
    }

    updateClockTickUI(step) {
        let length = this.length || this.sequencerEngine.length;
        step = step % length;
        let remainder = step % 4;
        if (remainder === 0) {
            let tickPercentage = 100 * (step / length);
            
            let clockTickPart = 25;
            if (tickPercentage >= 25 && tickPercentage < 50) {
                clockTickPart = 50;
            } else if (tickPercentage >= 50 && tickPercentage < 75) {
                clockTickPart = 75;
            } else if (tickPercentage >= 75) {
                clockTickPart = 100;
            }
            this.store.dispatch(setClockTick(clockTickPart));
        }
    }

    async signal(hash) {
        let data = await ipfs.getJson(hash);
        console.log('calling peer ignal with data =', data);
        this.peer.signal(data);
    }

    // publishes to ethereum that we are broadcasting as a
    // clock MASTER
    async publishMaster(hash, topic) {
        this.store.dispatch(setConnectionStatus(WAITING));
        let userId = await accounts.getAccount();
        fetch('/publishClock/' + userId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                clockType: MASTER,
                signal: hash
            })
        });
    }

    // publishes to ethereum that we are broadcasting as a
    // clock SLAVE
    async publishSlave(hash, userToConnectTo) {
        this.store.dispatch(setConnectionStatus(WAITING));
        let userId = await accounts.getAccount();
        fetch('/publishClock/' + userId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                clockType: SLAVE,
                signal: hash,
                userToConnectTo: userToConnectTo,
            })
        });
    }

    async onStop() {
        if (this.connected && this.initiator) {
            // tell the slave to stop playing
            this.peer.send(JSON.stringify({
                type: STOP}));
        }
    }

    async onBPMChanged(bpm) {
        if (this.connected && this.clockType === MASTER) {
            // send the new bpm to the slave
            this.peer.send(JSON.stringify({
                type: BPM_CHANGED,
                payload: bpm}));
        }
    }

    async onTick(time, step) {
        if (this.connected && this.clockType === MASTER) {
            // send the clock tick information to the slave
            this.peer.send(JSON.stringify({
                type: TICK,
                payload: {
                    step: step,
                    time: time,
                    length: this.sequencerEngine.length,
                }}));

            this.updateClockTickUI(step);
        }
    }

    get state() {
        return this.store.getState();
    }

    get isPlayScheduled() {
        return this.state.clock.playScheduled;
    }
}


export default ClockSync;
